import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

interface PaymentPlanWhatIsAutopayBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null>;
}

const PaymentPlanWhatIsAutopayBottomSheet = ({
  bottomSheetRef,
}: PaymentPlanWhatIsAutopayBottomSheetProps) => {
  const { t: translatedText } = useTranslation('payOverTime', {
    keyPrefix: 'paymentPlan.whatIsAutopayBottomSheet',
  });

  const handleClose = () => {
    bottomSheetRef.current?.close();
  };

  return (
    <BottomSheet
      ref={bottomSheetRef}
      analyticsId="/pay-over-time/payment-plan/paymentPlanWhatIsAutopayBottomSheetViewed"
      onDismiss={handleClose}
    >
      <View style={styles.container}>
        <View style={styles.copyContainer}>
          <TitleLgText numberOfLines={0}>{translatedText('title')}</TitleLgText>
          <BodyBaseText numberOfLines={0}>
            {translatedText('body')}
          </BodyBaseText>
        </View>
        <Button
          label={translatedText('gotIt')}
          type="PRIMARY"
          onPress={handleClose}
          analyticsId="paymentPlanWhatIsAutopayBottomSheetCloseClicked"
          width="FULL"
        />
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing.m,
    paddingBottom: theme.spacing.m,
  },
  copyContainer: {
    gap: theme.spacing.s,
    marginBottom: theme.spacing.xl,
  },
});

export default PaymentPlanWhatIsAutopayBottomSheet;
